module.exports = __webpack_public_path__ + "static/media/12UNCTAD6.e02703e4.jpg";